import React, { useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { tickColor, baseFont } from './chartConstants';

const ClaritaskComparisonChart = ({ claritaskTicketStats }) => {
    const single = claritaskTicketStats?.single ?? 0;
    const linked = claritaskTicketStats?.linked ?? 0;
    const total  = single + linked;

    const chartData = useMemo(() => {
        if (total === 0) return null;
        return {
            labels: ['Single Tickets', 'Linked with Claritask'],
            datasets: [{
                data: [single, linked],
                backgroundColor:      ['rgba(99, 102, 241, 0.85)', 'rgba(20, 184, 166, 0.85)'],
                hoverBackgroundColor: ['rgba(99, 102, 241, 1)',    'rgba(20, 184, 166, 1)'],
                borderWidth: 2,
                borderColor: '#fff',
            }],
        };
    }, [single, linked, total]);

    const options = {
        maintainAspectRatio: false,
        cutoutPercentage: 65,
        legend: {
            display: true,
            position: 'bottom',
            labels: { fontFamily: baseFont, fontSize: 12, fontColor: tickColor, padding: 16, boxWidth: 14 },
        },
        tooltips: {
            backgroundColor: '#1F2937',
            titleFontFamily: baseFont, titleFontSize: 12, titleFontStyle: 'bold',
            bodyFontFamily: baseFont,  bodyFontSize: 12,
            xPadding: 10, yPadding: 10,
            callbacks: {
                label: (item, data) => {
                    const label = data.labels[item.index];
                    const val   = data.datasets[0].data[item.index];
                    const pct   = total > 0 ? Math.round((val / total) * 100) : 0;
                    return ` ${label}: ${val} ticket${val !== 1 ? 's' : ''} (${pct}%)`;
                },
            },
        },
    };

    return (
        <div>
            {chartData ? (
                <>
                    <div style={{ height: '100%', minHeight: 160 }}><Doughnut data={chartData} options={options} /></div>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: 48, marginTop: 12 }}>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 22, fontWeight: 700, color: 'rgba(99,102,241,1)' }}>{single}</div>
                            <div style={{ fontSize: 11, color: tickColor }}>Single Tickets</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 22, fontWeight: 700, color: 'rgba(20,184,166,1)' }}>{linked}</div>
                            <div style={{ fontSize: 11, color: tickColor }}>Linked with Claritask</div>
                        </div>
                    </div>
                </>
            ) : (
                <div style={{ color: tickColor, padding: 20 }}>No ticket data available</div>
            )}
        </div>
    );
};

export default ClaritaskComparisonChart;
